import React from 'react';
import { useLocation } from 'react-router-dom';
import FieldGroupSchemaManager from '../admin/FieldGroupSchemaManager';
import { physSchemaClient } from '../../api/schema';

/** 材料模板 (2026-09-12 从「Schema 管理」拆出, 归材料主数据): 材料理化字段组. ?focus=<type1> 定位到该类别的组. */
function MaterialTemplateAdmin() {
    const focus = new URLSearchParams(useLocation().search).get('focus') || '';
    return (
        <FieldGroupSchemaManager
            client={physSchemaClient}
            resource="phys_schema"
            domainLabel="材料理化"
            valueHint="按材料 (xcode) 存值, 材料详情页录入"
            categoryScope
            matrixLayout
            focusTemplate={focus}
        />
    );
}

export default MaterialTemplateAdmin;
